import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Events, ModalController, Platform } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventEmitter } from '@angular/core';
import { SelectLanguagePage } from 'src/app/pages/select-language/select-language.page';
import { encodeURL } from 'src/app/services/parseURL';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { HeaderUtilsService } from '../header-utils.service';

@Component({
  selector: 'app-header-seven',
  templateUrl: './header-seven.component.html',
  styleUrls: ['./header-seven.component.scss'],
})
export class HeaderSevenComponent implements OnInit  {
  @Input() headerData: any;
  @Input() data: any;
  @Input() backButton: boolean;
  @Input() innerPage: boolean;
  @Input() region: any;
  @Output() openRegionModalEvent = new EventEmitter();
  @Input() stickyHeader: boolean;
  @Output() getStickyHeight = new EventEmitter();
  @Output() openSearchPageEvent = new EventEmitter();

  @ViewChild('searchContainer', {
      static: false
  }) searchContainer;

  displayMobileearch = false;
  loginStatus = false;
  searchText = '';
  typingTimer;
  doneTypingInterval = 1000;
  showSearchLoader: boolean = false;
  showNoProducts = false;
  algoliaProducts: any[] = [];
  noMoreProducts: boolean = false;
  isPriceReq: boolean;
  showPrices: boolean;
  page: number = 0;
  displaySearchResult;
  searchsubscribed: boolean = false;
  storeInfo;
  isOpenSearch = environment.openAlgoliaSearch;
  stickyHeight = 150;
  isIOS;

  role: any;
  userId: string = '';
  priceForRetail = false;
  currencyCode: any;
  RFQFeature = false;
  userPlace: { place: string; lat: any; lng: any; };
  constructor(private router: Router, private events: Events,
      private storage: Storage,
      private modalController: ModalController,
      private ngZone: NgZone,
      public userService: UserService,
      private utilsService: UtilsService,
      private configService: ConfigService,
      private platform: Platform,
      private headerUtilsService:HeaderUtilsService,
      private vendorService: VendorService) { }

  onClickDocument(event) {
      if (!this.searchContainer.nativeElement.contains(event.target)) { // or some similar check
          this.ngZone.run(() => {
              this.displaySearchResult = false;
          });
      }
  }

  openRegionModal(type) {
      this.openRegionModalEvent.emit(type);
  }

  async ngOnInit() {
      if (this.data) {
          console.log('data', this.data)
          this.role = this.data.role;
          this.priceForRetail = this.data.priceForRetail;
          this.currencyCode = this.data.currencyCode;
          this.RFQFeature = this.data.loginStatus;
      }

      this.platform.ready().then(() => {
          this.isIOS = this.platform.is('ios');
      });
      this.loginStatus = this.headerUtilsService.getLoginStatus();
      this.priceRequestFeature();

      await this.checkVendorSettingsForLocation();

      this.vendorService.userPlaceSub.subscribe(place => {
          this.userPlace = place;
      });

      this.isOpenSearch = this.configService.environment.openAlgoliaSearch;

  }

  toggleMobileSearch() {
      if (this.displayMobileearch == false) {
          this.displayMobileearch = true;
      } else {
          this.displayMobileearch = false;
      }
  }
  priceRequestFeature() {
      this.isPriceReq = this.configService.environment.priceReqFeature;
      if (this.isPriceReq) {
          this.storage.get('showPrices').then((val) => {
              this.showPrices = val;
              /* this.storage.get('userRole').then((role) => {
                   this.role = role;
               });*/
          });
      }
  }

  ngOnDestroy() {
      this.removeSubscriptions();
  }
  removeSubscriptions() {
    //   this.events.unsubscribe('search-engine:productSearchResults');
      this.events.unsubscribe('search-engine:noSearchProductsAvailable');
      this.events.unsubscribe('search-engine:noMoreSearchProducts');
      this.events.subscribe('auth:logoutSuccess', () => { })
  }

  subscribeSearch() {
      this.events.subscribe('search-engine:productSearchResults', (products) => {
          this.storage.get('userSubRole').then((subRole) => {
              if (subRole && subRole === 'retailer' && this.priceForRetail) {
                  products.forEach(pdt => {
                      let retailDiscount = pdt.retailDiscount ? pdt.retailDiscount : 0;
                      if (retailDiscount) {
                          if (!pdt.isPriceList) {
                              pdt.discountedPrice = pdt.prodPrice - (pdt.prodPrice * (retailDiscount / 100))
                          } else {
                              pdt.priceList.forEach(pl => {
                                  pl.discountedPrice = pl.price - (pl.price * (retailDiscount / 100))
                              });
                          }
                      }
                  });
              }
              console.log('products in searchhhh', products);
              this.displaySearchResult = true;
              this.algoliaProducts = products;
              this.showSearchLoader = false;
              this.showNoProducts = false;
          });
      });
      this.events.subscribe('search-engine:noSearchProductsAvailable', () => {
          this.showSearchLoader = false;
          this.showNoProducts = true;
      });
      this.events.subscribe('search-engine:noMoreSearchProducts', () => {
          this.noMoreProducts = true;
          this.showSearchLoader = false;
      });
  }

  fireSearchQuery() {
      if (this.userService.userId === '' && !this.isOpenSearch) {
          this.openLoginModal()
      } else {
          clearTimeout(this.typingTimer);
          if (this.searchText.length > 2 && (this.isOpenSearch || this.userService.getUserId())) {
              this.typingTimer = setTimeout(() => {
                  //// console.log('in fireSearchQuery...');
                  this.showSearchLoader = true;
                  this.showNoProducts = false;
                  if (!this.searchsubscribed) {
                      this.subscribeSearch();
                      this.searchsubscribed = true;
                  }
                  this.events.publish('search-engine:alogoliaSearchProducts', this.searchText, 0, 'new_search');
              }, this.doneTypingInterval);

          }
      }

  }
  showSearchResult() {
      console.log('showSearchResult')
      if (this.userService.userId === '' && !this.isOpenSearch) {
          this.openLoginModal()
      } else {
          this.displaySearchResult = true;
          console.log(this.displaySearchResult)
      }
  }

  async loadMoreProducts() {
      this.page = this.page + 1;
      this.events.publish('search-engine:alogoliaSearchProducts', this.searchText, this.page, 'existing_search');
  }

  urlName(pname: string) {
      return encodeURL(pname);
  }

  logout() {
      this.events.publish('auth:logout');
      this.events.publish('makeUnreadAdminMsgsZero');
  }

  urlSlug(value) {
      return encodeURL(value);
  }

  async openLoginModal() {
      this.searchText = '';
      this.utilsService.openLoginModal();
  }

  onClickProduct(pdt: any) {
      const name = encodeURL(pdt.prodName);
      if (pdt.ptype === 'child') {
          this.router.navigate([`product-details/${name}/${pdt.parentId}/option/${pdt.objectID}`]);
      } else {
          this.router.navigate([`product-details/${name}/${pdt.objectID}`]);
      }

      this.removeSubscriptions();
      this.searchsubscribed = false;
      this.searchText = '';
  }

  checkPdtStock(pdt) {
      let isOutOfStock = false;
      if (!pdt.isPriceList) {
          if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
              isOutOfStock = true;
          }
      } else {
          if (pdt.stopWhenNoQty) {
              for (let pl of pdt.priceList) {
                  if (pl.totalQuantity !== '0') {
                      isOutOfStock = false;
                      break;
                  } else {
                      isOutOfStock = true;
                  }
              }
          }
      }
      return isOutOfStock;
  }

  async openSelectLanguageModal() {
      const modal = await this.modalController.create({
          component: SelectLanguagePage,
          cssClass: 'custom-modal',
      });
      await modal.present();
  }

  openSearchPage() {
      // this.router.navigate(['search-items']);
      this.openSearchPageEvent.emit();
  }

  async checkVendorSettingsForLocation() {
      if(this.configService.environment.multiVendor) {
          await this.vendorService.getMultiVendorSettings();
      }
  }

  openUserPlaceModal(action: string) {
      this.vendorService.openPlaceModal(action);
  }

  isVendorBasedOnKm() {
      return this.vendorService.vendorSettings.vendorBasedOnKm; 
  }
}